<template>
  <div class="flex flex-row w-screen h-screen relative bg-gray-50">
    <BaseSidebar />
    <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll">
      <div class="border-b w-full flex flex-wrap space-y-2 p-4 justify-between">
        <div class="flex gap-x-1">
          <span class="flex items-center text-primary-500 font-bold">
            Settings
          </span>
        </div>
      </div>
      <div
        class="flex flex-row w-full h-screen h-full overflow-y-hidden"
      >
        <WorkspaceSettingSideBar />
        <div class="h-full w-full flex flex-col flex-1 bg-gray-100 overflow-y-auto">
          <div class="p-6 rounded-md contentContainer">
            <slot />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll overflow-x-hidden">
      <div class="container mx-auto p-4 lg:px-28 grid grid-cols-1 gap-y-3">
        <h1 class="text-2xl mb-4 circular-book">
          WorkSpace Settings
        </h1>
        <div class="border-b mb-2 gap-x-6 flex">
          <nuxt-link
            v-for="(tab, index) in tabs"
            :key="index"
            :to="tab.route"
            class="cursor-pointer"
            :class="tab.active? 'circular-black border-b border-b-4 border-black' : 'text-gray-500'"
          >
            {{ tab.name }}
          </nuxt-link>
        </div>
        <div class="w-full">
          <slot />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const routeName = computed(() => {
  return route.name as string
})
// const tabs = computed(() => {
//   return [
//     { name: 'Setting', route: { name: 'settings' }, active: routeName.value === 'settings' },
//   ]
// })
</script>
